<template>
  <div>

  </div>
</template>

<script>

  export default {
    name: 'ReceipesPlans',
  }
</script>